import React, { useState, useEffect } from "react";
import { FiSearch } from "react-icons/fi";
import {Grid, Button, FormControl, InputLabel, Select, MenuItem, Box} from "@mui/material";

const Search = ({ onSearchResults }) => {
  const [jobs, setJobs] = useState([]);
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [search, setSearch] = useState("");
  const [experience, setExperience] = useState("");
  const [skillset, setSkillset] = useState("");
  const [location, setLocation] = useState("");
  const [jobType, setJobType] = useState("");
  const [department, setDepartment] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  
  // Added state for dropdown options
  const [experiences, setExperiences] = useState([]);
  const [locations, setLocations] = useState([]);

  // Sort options
  const sortOptions = [
    { value: "newest", label: "Newest to Oldest" },
    { value: "oldest", label: "Oldest to Newest" }
  ];

  const fetchJobs = () => {
    fetch(`${process.env.REACT_APP_BACKEND_BASEURL}/api/jobs`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setJobs(data.data);
          setFilteredJobs(data.data);
          onSearchResults(data.data);
          
          // Extract unique values for dropdown options
          const uniqueExperiences = [...new Set(data.data.map(job => job.experience))].filter(Boolean);
          const uniqueLocations = [...new Set(data.data.map(job => job.location))].filter(Boolean);
          
          setExperiences(uniqueExperiences);
          setLocations(uniqueLocations);
        } else {
          console.error("Failed to fetch jobs:", data.message);
        }
      })
      .catch((err) => console.error("Error fetching jobs:", err));
  };

  useEffect(() => {
    fetchJobs();
  }, []);

  useEffect(() => {
    let filtered = jobs.filter((job) => {
      const searchTerms = search.toLowerCase().trim();
      const searchMatch = !searchTerms
        ? true
        : [job.title, job.experience, job.skillset, job.location, job.jobType, job.department].some(
            (field) => field && field.toString().toLowerCase().includes(searchTerms)
          );

      const experienceMatch = !experience || job.experience === experience;
      const skillsetMatch = !skillset || (job.skillset && job.skillset.includes(skillset));
      const locationMatch = !location || job.location === location;
      const jobTypeMatch = !jobType || job.jobType === jobType;
      const departmentMatch = !department || job.department === department;

      return searchMatch && experienceMatch && skillsetMatch && locationMatch && jobTypeMatch && departmentMatch;
    });

    if (sortOrder === "newest") {
      filtered.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    } else if (sortOrder === "oldest") {
      filtered.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    }

    setFilteredJobs(filtered);
    onSearchResults(filtered);
  }, [search, experience, skillset, location, jobType, department, sortOrder, jobs]);

  const handleSearch = () => {
    // This function triggers the existing useEffect that filters jobs
    // No additional logic needed as the state changes will trigger the filtering
  };

  return (
    <div style={{ padding: "0px 0px 16px 0px", maxWidth: "1100px", margin: "auto", textAlign: "center" }}>
      <Grid container style={{ border:"4px solid #1976d2", borderRadius: "8px", backgroundColor: "#fff", marginBottom:'16px', transition: "box-shadow 0.3s ease-in-out"}}
        onMouseEnter={(e) => e.currentTarget.style.border = "0px 6px 10px rgba(0, 0, 0, 0.15)"}
        onMouseLeave={(e) => e.currentTarget.style.boxShadow = "0px 6px 10px rgba(0, 0, 0, 0.15)"}
      >
        <Grid item xs={12} md={4} sx={{display:"flex", paddingLeft:"16px", justifyContent:"center", alignItems:"center"}}>
          <FiSearch style={{color:"#1976d2", fontSize:"24px"}} />
          <input 
            type="text" 
            value={search} 
            onChange={(e) => setSearch(e.target.value)} 
            placeholder="Search jobs..."
            style={{width: "100%", padding: "8px 16px", marginTop:"5px", border: "none", fontSize:"14px", outline: "none"}} 
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <FormControl fullWidth sx={{px:"10px"}}>
            <InputLabel sx={{fontSize: {xs: '12px', sm: '13px', }, marginTop:"2px"}}>Search By Experience</InputLabel>
            <Select 
              value={experience}
              onChange={(e) => setExperience(e.target.value)}
              label="Experience Level" 
              sx={{
                '& .MuiOutlinedInput-notchedOutline': {border: 'none'},
                '&:hover .MuiOutlinedInput-notchedOutline': {border: 'none'},
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {border: 'none'},
              }}
            >
              <MenuItem value="">All Experience</MenuItem>
              {experiences.map((exp) => (
                <MenuItem key={exp} value={exp}>{exp}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6} md={3}>
          <FormControl fullWidth sx={{px:"10px"}}>
            <InputLabel sx={{fontSize: {xs: '12px', sm: '13px', }, marginTop:'2px'}}>Search By Location</InputLabel>
            <Select 
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              label="Location" 
              sx={{
                '& .MuiOutlinedInput-notchedOutline': {border: 'none'},
                '&:hover .MuiOutlinedInput-notchedOutline': {border: 'none'},
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {border: 'none'},
              }}
            >
              <MenuItem value="">All Locations</MenuItem>
              {locations.map((loc) => (
                <MenuItem key={loc} value={loc}>{loc}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {/* <Grid item xs={12} md={3}>
          <FormControl fullWidth sx={{px:"10px"}}>
            <InputLabel sx={{ fontSize:'13px', marginTop:"2px"}}>Sort By</InputLabel>
            <Select 
              value={sortOrder}
              onChange={(e) => setSortOrder(e.target.value)}
              label="Sort By" 
              sx={{
                '& .MuiOutlinedInput-notchedOutline': {border: 'none'},
                '&:hover .MuiOutlinedInput-notchedOutline': {border: 'none'},
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {border: 'none'},
              }}
            >
              <MenuItem value="">Default</MenuItem>
              {sortOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid> */}
        <Grid item xs={12} md={2} sx={{p:{xs:2, sm:3, md:0}}}>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleSearch}
            sx={{py:1, px:2.5, borderRadius: "0px", minWidth:"100%", height:"100%", fontSize: "0.85rem", boxShadow:0, border:"solid 4px #fff"}}
          >
            Search
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default Search;